import { useStore } from "@/shared/store/useStore.js";
import modalStore from "@/shared/store/modalStore.js";
import PrivacyModal from "./modals/PrivacyModal.jsx";
import TermsModal from "./modals/TermsModal.jsx";
import AboutModal from "./modals/AboutModal.jsx";
import FAQModal from "./modals/FAQModal.jsx";

/**
 * Modal orchestrator — reads the three open/close flags from `modalStore`
 * and mounts the matching modal. Each modal owns its own copy/layout in
 * ./modals/<Name>Modal.jsx; the shared overlay/header/footer chrome lives
 * in ./modals/ModalShell.jsx.
 */
export default function Modals() {
  const showPrivacy = useStore(modalStore, (s) => s.showPrivacy);
  const showTerms   = useStore(modalStore, (s) => s.showTerms);
  const showAbout   = useStore(modalStore, (s) => s.showAbout);
  const showFAQ     = useStore(modalStore, (s) => s.showFAQ);

  return (
    <>
      {showPrivacy && <PrivacyModal onClose={() => { modalStore.showPrivacy = false; }} />}
      {showTerms && <TermsModal onClose={() => { modalStore.showTerms = false; }} />}
      {showAbout && <AboutModal onClose={() => { modalStore.showAbout = false; }} />}
      {showFAQ && <FAQModal onClose={() => { modalStore.showFAQ = false; }} />}
    </>
  );
}
